// extracted by mini-css-extract-plugin
module.exports = {"actionBtnCornerAdv":"index_actionBtnCornerAdv_1Ztl6"};